import { RangeDateTypeHr } from 'src/types/date.type';
import { FlatItem, TicketResponses } from 'src/types/elements.type';
import { ApprovalStatus } from 'src/types/helpdesk/ticket.type';
import { IPurchaseRequestTicket, PurchaseRequestTicketAdd } from 'src/types/hr_ticket/purchaseRequestTicket.type';
import { PagedList } from 'src/types/pagedList.type';
import { ITicketParams } from 'src/types/params.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/purchase-request-tickets';

export const getPurchaseRequestTickets = async (params: ITicketParams) => {
  return await http.get<PagedList<IPurchaseRequestTicket>>(controller, {
    params: params
  });
};

export const getPurchaseRequestTicketsApproval = async (params: ITicketParams) => {
  return await http.get<PagedList<IPurchaseRequestTicket>>(`${controller}/waiting-approval`, {
    params: params
  });
};

export const getPurchaseRequestTicket = async (id: number) => {
  return await http.get<IPurchaseRequestTicket>(`${controller}/${id}`);
};

export const getPurchaseRequestTicketsDropdown = async () => {
  return await http.get<FlatItem[]>(`${controller}/dropdown`);
};

export const addPurchaseRequestTicket = async (purchaseRequestTicket: PurchaseRequestTicketAdd) => {
  return await http.post(controller, purchaseRequestTicket);
};

export const updatePurchaseRequestTicket = async (id: number, purchaseRequestTicket: PurchaseRequestTicketAdd) => {
  return await http.put(`${controller}/${id}`, purchaseRequestTicket);
};

export const deletePurchaseRequestTicket = async (id: number) => {
  return await http.delete(`${controller}/${id}`);
};

export const cancelPurchaseRequestTicket = async (id: number) => {
  return await http.put(`${controller}/${id}/cancel`);
};

export const approvalPurchaseRequestTickets = async (
  ticketResponses: TicketResponses[],
  approvalStatus: ApprovalStatus,
  note?: string
) =>
  await http.put(`${controller}/approvals`, {
    ticketResponses: ticketResponses,
    approvalStatus,
    note: note ? note : ''
  });

export const cancelApprovalPurchaseRequestTickets = async (id: string, step: number) =>
  await http.put(`${controller}/${id}/cancel-approval`, { step });

export const getRefPurchaseRequestTicketsForTicket = async (refTicketId: string) =>
  await http.get<IPurchaseRequestTicket[]>(`${controller}/get-ref-tickets/${refTicketId}`);

export const getPurchaseRequestWaitingProcessingCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-ticket-waiting-processing`, {
    params: params
  });
};

export const getMyPurchaseRequestTicketCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-my-tickets`, {
    params: params
  });
};

export const getPurchaseRequestTicketApprovalCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-handle-tickets`, {
    params: params
  });
};

export const printPurchaseRequestTicket = async (id: number) =>
  await http.get(`${controller}/print`, {
    params: {
      id: id
    },
    responseType: 'blob'
  });
